<!-- unauthorized.component.html -->
<div class="text-center h-screen justify-center items-center flex flex-col">
  <h1 class="mb-[10px]" i18n>Access Denied</h1>
  <p class="mb-[10px]" i18n>You do not have permission to view this page.</p>
  <a class="home-button" routerLink="/" i18n>Return to Home</a>
</div>
